module.exports = __webpack_public_path__ + "static/media/bonnie-eisenman_200x200.a0aa6ff8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/img/speakers/bonnie-eisenman_200x200.jpg
// module id = 195
// module chunks = 0